<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input lazy"
                @submit.prevent="storeRecipient">
            <v-card style="position: relative;">
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>New Member</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>
                <v-overlay :model-value="!formReady" contained class="align-center justify-center">
                    <v-progress-circular indeterminate color="primary"/>
                </v-overlay>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row v-if="!type">
                        <v-col cols="12">
                            <v-select v-model="formData['user_id']" :items="users" density="compact"
                                      item-title="first_name" item-value="id" label="User">
                                <template v-slot:item="{ props, item }">
                                    <v-list-item :subtitle="item.raw.email"
                                                 :title="`${item.raw.first_name} ${item.raw.last_name}`"
                                                 v-bind="props"></v-list-item>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col sm="6">
                            <v-switch v-model="formData['app_enabled']" color="primary" density="compact" label="App"/>
                        </v-col>
                        <v-col sm="6">
                            <v-switch v-model="formData['email_enabled']" color="primary" density="compact"
                                      label="Email"/>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="6">
                            <v-text-field v-model="formData['recipient']" autofocus :rules="[vRules.required]"
                                          type="email" density="compact" label="Email"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button" @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const formReady = ref(false);
const users = ref([]);
const errors = ref([]);
const snackbar = useSnackbarStore();
const props = defineProps({
    group: Object,
    type: Number,
    modelValue: Boolean,
});
const dialogSwitch = ref(props.modelValue);
const formData = reactive({
    valid: false,
    user_id: null,
    recipient: null,
    type: props.type,
    app_enabled: true,
    sms_enabled: false,
    email_enabled: props.type === 1,
    group_id: props.group.id,
});
const emits = defineEmits(['update:modelValue', 'addRecipient']);

onMounted(() => {
    const promises = [];
    if (props.type === 0) {
        promises.push(fetchUsers());
    }
    Promise.all(promises).finally(() => formReady.value = true);
})
const fetchUsers = () => {
    return send('get', `companies/${props.group.company_id}/users?list=true&include_self=1`)
        .then((response) => {
            users.value = response.data.data.users;
        })
        .catch(() => {
            snackbar.showSnackbar('Users could not be loaded', 'error')
        })
}
const storeRecipient = () => {
    errors.value = [];
    send('post', `monitoring/notification-group-members`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('addRecipient', response.data.data.member);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
